import { render, staticRenderFns } from "./ConfigurationIndex.vue?vue&type=template&id=733f9788&"
import script from "./ConfigurationIndex.vue?vue&type=script&lang=js&"
export * from "./ConfigurationIndex.vue?vue&type=script&lang=js&"
import style0 from "./ConfigurationIndex.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports